import './plugins/i18n';

import { RouterProvider } from 'react-router-dom';

import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { defaultStorage } from 'aws-amplify/utils';
import ReactDOM from 'react-dom/client';
import router from 'router/router';

import awsconfig from './aws-exports';
import reportWebVitals from './reportWebVitals';

import './index.scss';

Amplify.configure(awsconfig);
cognitoUserPoolsTokenProvider.setKeyValueStorage(defaultStorage);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  // <React.StrictMode>
  <RouterProvider router={router} />,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
